import React, { type FC } from 'react'

import classes from './LiveStreamInfo.module.scss'

type LiveStreamInfoProps = {
  title: string
}

export const LiveStreamInfo: FC<LiveStreamInfoProps> = ({ title }) => {
  return <div className={classes.Title}>{title}</div>
}
